const AUTH_STORAGE_KEYS = [
	'token',
	'user_data',
	'nameUser',
	'lastName',
	'urlPhoto',
	'idUser',
	'email',
	'rol',
	'rol_and_permissions',
]

export const clearAuthSession = () => {
	AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
}

export const getAccessToken = () => localStorage.getItem('token') || ''

const decodeJwtPayload = (token) => {
	const payload = token?.split('.')?.[1]
	if (!payload) return null

	try {
		const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/')
		const decodedPayload = atob(normalizedPayload)
		return JSON.parse(decodedPayload)
	} catch (error) {
		return null
	}
}

const isTokenExpired = (token) => {
	const payload = decodeJwtPayload(token)
	if (!payload?.exp) return true

	return payload.exp * 1000 <= Date.now()
}

export const getStoredAuthSession = () => {
	const token = getAccessToken()
	const userData = localStorage.getItem('user_data')

	if (!token || !userData || isTokenExpired(token)) {
		clearAuthSession()
		return null
	}

	try {
		return {
			token,
			user: JSON.parse(userData),
		}
	} catch (error) {
		clearAuthSession()
		return null
	}
}
